export var initializeCookiebot = function initializeCookiebot(_ref) {
  var commit = _ref.commit,
    dispatch = _ref.dispatch;
  var handleCookiebotLoad = function handleCookiebotLoad() {
    if (process.env.NODE_ENV === 'development') {
      console.info('✅ Cookiebot loaded via CookiebotOnLoad event');
    }
    commit('setCookiebotFailed', false);
    dispatch('handleCookiebotReady');
    // Keep listener active for page refreshes - don't remove it
  };

  // Force reinitialization on every init (handles soft refreshes)
  if (window.Cookiebot) {
    if (window.Cookiebot.loaded) {
      if (process.env.NODE_ENV === 'development') {
        console.info('✅ Cookiebot already loaded - reinitializing');
      }
      // Ensure Cookiebot is in a valid state after refresh
      dispatch('handleCookiebotReady');
    } else {
      if (process.env.NODE_ENV === 'development') {
        console.info('⏳ Cookiebot exists but not loaded - waiting for load event');
      }
    }
  }

  // Always ensure event listener is attached (idempotent)
  window.removeEventListener('CookiebotOnLoad', handleCookiebotLoad);
  window.addEventListener('CookiebotOnLoad', handleCookiebotLoad);

  // Cookiebot doesn't always fire CookiebotOnLoad reliably (e.g. when its async
  // load finishes before our listener is attached), so poll as a fallback. Once
  // Cookiebot.loaded flips to true we run the same handler the event would.
  var pollStart = Date.now();
  var invoked = false;
  var pollInterval = setInterval(function () {
    if (window.Cookiebot && window.Cookiebot.loaded) {
      clearInterval(pollInterval);
      if (!invoked) {
        invoked = true;
        handleCookiebotLoad();
      }
    } else if (Date.now() - pollStart >= 2000) {
      clearInterval(pollInterval);
      console.warn('⚠️ Cookiebot failed to load within timeout period (2s)');
      commit('setCookiebotFailed', true);
      commit('setCookiebotLoaded', true);
    }
  }, 50);
};
export var handleCookiebotReady = function handleCookiebotReady(_ref2) {
  var dispatch = _ref2.dispatch;
  // Hide Cookiebot's native dialog immediately to prevent it from auto-showing
  // alongside our custom banner. Any delay here causes a visible flicker.
  dispatch('hideCookiebot');
};
export var hideCookiebot = function hideCookiebot(_ref3) {
  var commit = _ref3.commit,
    getters = _ref3.getters;
  var safeCookiebotMethod = getters.safeCookiebotMethod;
  var hideSuccess = safeCookiebotMethod('hide');
  if (hideSuccess || !window.Cookiebot) {
    commit('setCookiebotLoaded', true);
    if (process.env.NODE_ENV === 'development') {
      console.info(hideSuccess ? '✅ Cookiebot hidden successfully' : '⚠️ Cookiebot hide failed but continuing');
    }
  } else {
    setTimeout(function () {
      safeCookiebotMethod('hide');
      commit('setCookiebotLoaded', true);
    }, 1000);
  }
};